module.exports = __webpack_public_path__ + "img/chat.57be4d06.svg";